import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/r-project': {
    width: 581,
    height: 512,
    paths: [
      {
        d: 'M581 226.6c0 54.8-33.9 104.3-88.4 139.7l67.4 113.7h-112l-40.1-75.4c-21.8 6.5-45.1 11.2-69.4 13.9v61.5h-99.1v-61.9c-136.1-16.1-239.4-95.7-239.4-191.5 0-107.5 130.1-194.6 290.5-194.6s290.5 87.1 290.5 194.6zM114.2 241.1c0 52.8 51.1 98.4 125.2 119.9v-208.3h199s90.6 1.6 90.6 87.9c0 86.3-86.6 92.7-86.6 92.7s17.6 5.3 27.8 10.5c1.7 0.8 4 2.1 6.4 3.7 43.8-21.4 70.3-56.3 70.3-106.4 0-92.3-90-133-211.9-133s-220.8 59.5-220.8 133zM339.3 279.4c49.6 0 87.8 8.2 87.8-28.3 0-34.1-30-27.3-87.8-27.3v55.6zM338.4 351.9v22.1c17.6-0.1 34.5-1 50.6-2.9-5.1-7.5-13.2-19.2-24-19.2h-26.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/r-project.js
// module id = 983
// module chunks = 0